console.log('✅ basic-bottom-pagination.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';

export async function buildComponentBasicBottomPagination({
  containerId,
  totalPages,
  currentPage,
  itemsPerPageOptions = [1, 2, 3, 5, 6, 12, 100],
  currentItemsPerPage = 6,
  onPageChange,
  onItemsPerPageChange,
  sortMethod,
  currentUrl,
  lang,
} = {}) {
  console.log(`🔄 Building Component: buildComponentBasicBottomPagination - lang: ${lang}`);

  try {
    // alert(currentItemsPerPage);
    // alert("buildComponentBasicBottomPagination");

    // ✅ Fetch all translations in parallel
    const [lblItemsPerPage, linkPaymentProtection] = await Promise.all([
      getTextTranslationByKey('keyItemsPerPage', lang),

      getLinksTranslationByKey('keyPaymentProtection', lang),
    ]);

    const imgSrcForIcons = `${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/arrow-up.svg`;

    const linkButtonsForPages = await buildComponentBasicBottomPaginationPageNumbersButtonLinksOnly(
      containerId,
      onPageChange,
      totalPages,
      currentPage,
      currentItemsPerPage,
      sortMethod,
      currentUrl
    );

    const html = `
           <div class="grid-resultItemNumber-and-pagination-regular-wrapper">

                        <div class="search-page-result-to-show-grid">

                               <div class="search-page-result-to-show-count-resultnumber">
                                <select class="search-page-result-to-show-dropdown" id="dropDownResultItemsPerPage">
                                    ${itemsPerPageOptions
                                      .map(
                                        option => `
                                        <option value="${option}" ${
                                          option === currentItemsPerPage ? 'selected' : ''
                                        }>
                                            ${option}
                                            </option>
                                            `
                                      )
                                      .join('')}
                                            


                                  
                                </select>
                                <label for="dropDownResultItemsPerPage">${lblItemsPerPage}</label>
                                </div>

                                <div class="search-page-result-to-show-count-listOfPage-section">
                                    <div id="divHolderOfPageNavigationButtons" class="grid-page-buttons">
                                                                      
                                      ${linkButtonsForPages}
                                     
                                    </div>
                                </div>
                         </div>
            </div>             



        `;

    console.log('✅ BasicBottomPagination built successfully.');

    // Register event listeners
    //registerEventListenerToAttach(attachEventListenersBasicBottomPagination);
    //  registerEventListenerToAttach(async () => attachEventListenersBasicBottomPagination(containerId, onItemsPerPageChange, onPageChange));

    return html;
  } catch (err) {
    console.error('❌ Error building BasicBottomPagination:', err);
    return '<div>BasicBottomPagination could not be loaded.</div>';
  }
}

export async function attachEventListenersBasicBottomPagination(
  containerId,
  onItemsPerPageChange,
  onPageChange
) {
  // alert("attachEventListenersBasicBottomPagination");

  try {
    const container = containerId ? document.getElementById(containerId) : null;

    if (!container) {
      console.warn('⚠️ BasicBottomPagination Missing containerId or invalid element');
      return `<div style="color:red;">⚠️ Missing pagination containerId or invalid container element.</div>`;
    } else {
      // 📌 Clean old listeners (replace node to reset listeners)
      const dropdown = container.querySelector('#dropDownResultItemsPerPage');
      if (dropdown) {
        const clone = dropdown.cloneNode(true);
        dropdown.parentNode.replaceChild(clone, dropdown);

        clone.addEventListener('change', e => {
          onItemsPerPageChange(Number(e.target.value));
        });
      }

      container.querySelectorAll('.page-button').forEach(a => {
        // Remove any existing click listener to prevent duplicates
        const clone = a.cloneNode(true);
        a.replaceWith(clone);

        clone.addEventListener('click', e => {
          e.preventDefault(); // ✅ Prevent anchor navigation
          e.stopImmediatePropagation(); // ✅ Stop any other listeners
          const pageIndex = parseInt(clone.dataset.pageIndex, 10);
          if (!isNaN(pageIndex)) {
            onPageChange(pageIndex); // Call your page update function
          }
        });
      });

      console.log('✅ Pagination event listeners reattached.');
    }
  } catch (error) {
    console.error('❌ Error attaching BasicBottomPagination listeners:', error);
  }
}

async function buildComponentBasicBottomPaginationPageNumbersButtonLinksOnly(
  containerId,
  onPageChange,
  totalPages,
  currentPage,
  currentItemsPerPage,
  sortMethod,
  currentUrl
) {
  const html = ` 
    
    ${Array.from({ length: totalPages }, (_, index) => {
      const pageIndex = index + 1;

      const paginationURLLink = `${currentUrl}?page=${pageIndex}&size=${currentItemsPerPage}&sort=${sortMethod}`;

      return `
                               <a href="${paginationURLLink}" class="page-button ${
        pageIndex === currentPage ? 'current' : ''
      }"
                                    aria-current="${pageIndex === currentPage ? 'current' : ''}"
                                    aria-label="Go to page ${pageIndex}"
                                    data-page-index="${pageIndex}">
                                    ${pageIndex}
                                </a>
                            `;
    }).join('')}

    `;

  console.log('✅ BasicBottomPaginationPageNumbersButtonLinksOnly built successfully.');

  return html;
}
